module.exports = __webpack_public_path__ + "img/play.e9dddd83.png";